import { Routes } from '@angular/router'

export const routes: Routes = [
  {
    // authGuard on 'dashboard' handles bouncing unauthenticated users to sign-in with a returnUrl.
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    loadChildren: () =>
      import('./views/views.route').then((mod) => mod.VIEW_ROUTES),
  },
]
